import {
  Node
} from 'slate';

import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import types from '../../elements/types';
import HelptapEditor from '../../helpers';

export default function withPasteProcessor(editor) {

  const { insertTextData, insertData, insertFragment } = editor;

  function insertTextFragments(fragments) {

    for (let stat of fragments) {

      const type = stat.type;
      if (type === 'text') {
        HelptapEditor.insertWord(editor, stat.text);
      } else if (type === 'link') {
        HelptapEditor.insertLink(editor, stat.url, stat.text);
      }

    }

  }

  editor.insertTextData = function _insertTextData(data) {

    const text = data.getData('text/plain');

    const results = HelptapEditor.text.parseText(text);

    insertTextFragments(results);

    if (results.length === 0) {
      insertTextData(data);
    }

  };

  editor.insertData = function _insertData(data) {

    const html = data.getData('text/html');
    const markdown = data.getData('text/markdown');
    const parentBlock = HelptapEditor.getParentBlock(editor);

    if (parentBlock.type === types.TABLE) {

      const text = data.getData('text/plain');
      const results = HelptapEditor.text.parseText(text);

      insertTextFragments(results);

      return;

    }

    if (html !== void 0 && (typeof html === 'string' && html.trim() !== '')) {

      try {

        const nodes = HelptapEditor.htmlImporter.fromString(html);
        if (nodes.length !== 0) {
          HelptapEditor.insertNodesReplacingEmptyBlock(editor, HelptapEditor.trim(editor, nodes));
          return;
        }

      } catch (exception) {
        // eslint-disable-next-line no-console
        console.log(exception);
        application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
          message: 'Unable to paste copied content. Contact administrator!',
          seconds: 5,
          type: 'error'
        });

      }
    } else if (markdown !== void 0 && (typeof markdown === 'string' && markdown.trim() !== '')) {

      basicEditorValueSerializer.converters.fromMarkdown(markdown).then(function onSuccess(nodes) {
        HelptapEditor.insertNodes(editor, nodes);
      }).catch(function onError(exception) {
        // eslint-disable-next-line no-console
        console.log(exception);
        application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
          message: 'Unable to paste copied content. Contact administrator!',
          seconds: 5,
          type: 'error'
        });
      });
      return;

    }

    const node = HelptapEditor.text.tryGetNode(data.getData('text/plain'));

    if (node !== null) {
      HelptapEditor.insertNodeFromClipboard(editor, node);
    } else {
      insertData(data);
    }

  };

  editor.insertFragment = function _insertFragment(fragment) {

    const canEdit = HelptapEditor.isEditableNodeSelected(editor);

    if (canEdit === false) {
      return insertFragment(fragment);
    }

    const textFromFragment = fragment.map(Node.string).join('');

    editor.insertText(textFromFragment);

  };

  return editor;

}